import { apiClient } from './client';
import type { Customer } from '../types';

interface UpdateCustomerParams {
  first_name: string;
  last_name?: string;
  phone?: string;
}

export const customersApi = {
  // Get current user info
  getMe: () => apiClient.get<Customer>('/customers/me'),

  // Update current user info
  updateMe: (params: UpdateCustomerParams) =>
    apiClient.put<Customer>('/customers/me', params),
};
